import { RecurringRuleRuleTypeEnum } from 'graphql-common';

export default function getRecurringRuleTypeName(
  recurringRuleType: RecurringRuleRuleTypeEnum,
) {
  switch (recurringRuleType) {
    case RecurringRuleRuleTypeEnum.Daily:
      return 'day-plural';
    case RecurringRuleRuleTypeEnum.Weekly:
      return 'week-plural';
    case RecurringRuleRuleTypeEnum.Monthly:
      return 'month-plural';
    case RecurringRuleRuleTypeEnum.Yearly:
      return 'year-plural';
    default:
      return '';
  }
}
